module.exports = __webpack_public_path__ + "img/shopping_application_3-2.a576c6d3.jpg";